export const createApplicationAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }